import { Box, HStack } from "@chakra-ui/react";
import { ReactNode } from "react";

export const MapColoringLegendItem = ({
  color,
  children,
}: {
  color: string;
  children: ReactNode;
}) => {
  return (
    <HStack>
      <Box bg={color} w="6px" h="6px" borderRadius="3px" flexShrink={0} />
      <Box fontSize="xs">{children}</Box>
    </HStack>
  );
};
